import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/snapchat-ghost': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.8 392.7c-5.2 12.2-27.2 21.1-67.4 27.3-2.1 2.8-3.8 14.7-6.5 24-1.6 5.6-5.6 8.9-12.1 8.9l-0.3 0c-9.4 0-19.2-4.3-38.9-4.3-26.5 0-35.7 6-56.3 20.6-21.8 15.4-42.8 28.8-74 27.4-31.6 2.3-58-16.9-72.9-27.4-20.7-14.6-29.8-20.6-56.2-20.6-18.9 0-30.7 4.7-38.9 4.7-8.1 0-11.2-4.9-12.4-9-2.7-9.2-4.4-21.3-6.5-24.1-20.7-3.2-67.3-11.3-68.5-32.2 0-0.2 0-0.4 0-0.6 0-5 4-9.7 8.9-10.5 69.6-11.5 100.9-82.9 102.2-85.9 0.1-0.2 0.2-0.3 0.2-0.5 3.7-7.5 4.5-13.8 2.5-18.8-5.1-11.9-26.9-16.2-36.1-19.8-23.7-9.4-27-20.1-25.6-27.5 2.4-12.8 21.7-20.7 33-15.5 8.9 4.2 16.8 6.3 23.5 6.3 5 0 8.2-1.2 10-2.2-2-35.9-7.1-87.3 5.7-116 33.8-75.7 105.4-81.6 126.5-81.6 0.9 0 9.1-0.1 10.1-0.1 52.1 0 102.3 26.8 126.7 81.6 12.8 28.7 7.7 79.8 5.7 116 1.6 0.9 4.4 1.9 8.6 2.1 6.4-0.3 13.8-2.4 22.1-6.3 6.1-2.8 14.4-2.5 20.5 0.1l0 0c9.5 3.4 15.4 10.2 15.6 17.9 0.2 9.7-8.5 18.2-25.9 25-2.1 0.8-4.7 1.7-7.4 2.5-9.8 3.1-24.6 7.8-28.6 17.3-2.1 4.9-1.3 11.2 2.5 18.7 0.1 0.2 0.2 0.3 0.2 0.5 1.3 3 32.6 74.5 102.2 85.9 6.4 1.1 11.2 7.9 7.7 15.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/snapchat-ghost.js
// module id = 1022
// module chunks = 0